import { IBlogRollMagazineWidgetStyle, BlogRollWidgetData } from "@pageBuilder/typings";
import { CssProperties } from "../../../models/css-property";
import { BlogRollBaseStylesRenderer } from "./blog-roll-styles-renderer";

export class BlogRollMagazineStylesRenderer extends BlogRollBaseStylesRenderer {

    public override render(element: HTMLElement, style: IBlogRollMagazineWidgetStyle): void {
        super.render(element, style);

        const lineProps = new CssProperties();
        lineProps.tryAdd("border-color", style.titleColor);
        this.styleService.setStyle(element, `#${element.id} .post-content`, lineProps.data);

        const magazinePostContentStyle = new CssProperties();
        magazinePostContentStyle.tryAdd("background", style.postBackground);
        this.styleService.setStyle(element, `#${element.id}.layout-magazine .post-list .post-content-wrapper`, magazinePostContentStyle.data);

        const magazinePostWrapperStyle = new CssProperties();
        magazinePostWrapperStyle.tryAdd("border-width", style.borderWidth);
        magazinePostWrapperStyle.tryAdd("border-color", style.borderColor);
        magazinePostWrapperStyle.tryAdd("border-style", "solid");
        this.styleService.setStyle(element, `#${element.id} .post-wrapper`, magazinePostWrapperStyle.data);

        const columnsWrapperStyle = new CssProperties();
        columnsWrapperStyle.tryAdd("background-color", style.postListBackground);
        this.styleService.setStyle(element, `#${element.id} .columns-wrapper`, columnsWrapperStyle.data);
    }

    public override getStyleSelectors(element: HTMLElement): string[] {
        const selectors = super.getStyleSelectors(element);
        const magazineSelectors = [
            `#${element.id} .post-content`,
            `#${element.id} .post-wrapper`,
            `#${element.id} .columns-wrapper`,
            `#${element.id}.layout-magazine .post-list .post-content-wrapper`
        ];
        selectors.push(...magazineSelectors);
        return selectors;
    }

    public partialUpdateWithDefaults(style: IBlogRollMagazineWidgetStyle): void {
        style.titleColor = BlogRollWidgetData.defaultMagazineStyle.titleColor;
        style.authorColor = BlogRollWidgetData.defaultMagazineStyle.authorColor;
        style.publishDateColor = BlogRollWidgetData.defaultMagazineStyle.publishDateColor;
        style.postBackground = BlogRollWidgetData.defaultMagazineStyle.postBackground;
    }

}
